<template>
  <section class="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-gray-100">
    <div class="text-center animate-fadeIn">
        <img src="../assets/images/erreur_404.webp" alt="404 Illustration" class="mx-auto w-80 animate-[float_3s_infinite] shadow-xl rounded-lg">
        <h1 class="text-7xl font-extrabold text-navigation mt-6">Une erreur s'est produite!</h1>
        <p class="text-xl text-gray-700 mt-2">Nous ne trouvons pas la page demandée.</p>
        <router-link to="/" class="mt-6 inline-block bg-secondaire text-white px-8 py-3 rounded-full text-lg font-semibold shadow-lg transform transition hover:scale-105 hover:bg-navigation" aria-label="Retour à l'accueil" title="Retour à l'accueil">Retour Accueil</router-link>
    </div>
  </section>

</template>

<script setup>


</script>

<style scoped>
  @keyframes float {
    0% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
    100% { transform: translateY(0); }
    }
</style>